import React from 'react';
import { Shield, CheckCircle, FileText, AlertTriangle } from 'lucide-react';

const ConformiteCarsat = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Hero */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-12 h-12 text-orange-500" />
            <h1 className="text-4xl sm:text-5xl font-bold">
              Équipements de Quai <span className="text-orange-500">Conformes Carsat</span>
            </h1>
          </div>
          <p className="text-xl text-slate-300 max-w-3xl">
            Tous nos équipements respectent les normes Carsat et réglementations en vigueur pour garantir la sécurité de vos opérateurs.
          </p>
        </div>
      </section>

      {/* Pourquoi c'est obligatoire */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-r-xl mb-12">
          <div className="flex items-start gap-4">
            <AlertTriangle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                Obligation Légale pour les Entreprises
              </h3>
              <p className="text-slate-700">
                Selon le <strong>Code du Travail (articles R4323-1 et suivants)</strong>, tout équipement de travail doit être conforme aux normes de sécurité. 
                En cas de contrôle Carsat ou d'accident, la non-conformité engage la responsabilité pénale du chef d'entreprise.
              </p>
            </div>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-slate-900 mb-12 text-center">
          Normes et Réglementations Respectées
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <FileText className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Norme R408</h3>
            <p className="text-slate-600 mb-4">
              Recommandation CNAMTS relative à la conception, l'aménagement et l'équipement des quais à marchandises.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Hauteur et largeur des quais</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Éclairage et signalisation</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Dispositifs de sécurité</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <FileText className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Norme R430</h3>
            <p className="text-slate-600 mb-4">
              Prévention des accidents lors des opérations de chargement et déchargement.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Protection anti-chute</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Garde-corps obligatoires</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Balisage des zones dangereuses</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <FileText className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Directive Machines 2006/42/CE</h3>
            <p className="text-slate-600 mb-4">
              Marquage CE obligatoire pour tous les équipements mécaniques.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Marquage CE</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Notice d'utilisation FR</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span>Déclaration de conformité</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Nos Garanties */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-12 text-center">
            Nos Garanties de Conformité
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Installation Conforme</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Dossier technique complet</strong> fourni après installation (plans, certificats, notices)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Attestation de conformité Carsat</strong> signée et tamponnée
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Tests de charge</strong> et vérifications avant mise en service
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Formation des opérateurs</strong> à l'utilisation sécurisée
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Suivi Réglementaire</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-slate-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Contrat de maintenance préventive</strong> pour rester conforme
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-slate-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Vérifications périodiques obligatoires</strong> (annuelles)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-slate-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Mise à jour réglementaire</strong> si évolution des normes
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-slate-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">
                    <strong>Assistance en cas de contrôle</strong> Carsat ou inspection du travail
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Risques de non-conformité */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">
            Risques de la Non-Conformité
          </h2>

          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-8">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-bold text-slate-900 mb-3 text-lg">⚖️ Sanctions Légales</h3>
                <ul className="space-y-2 text-slate-700 text-sm">
                  <li>• Amende jusqu'à 10 000€</li>
                  <li>• Fermeture administrative du site</li>
                  <li>• Responsabilité pénale du dirigeant</li>
                  <li>• Poursuites en cas d'accident</li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 mb-3 text-lg">💰 Conséquences Financières</h3>
                <ul className="space-y-2 text-slate-700 text-sm">
                  <li>• Augmentation cotisations AT/MP</li>
                  <li>• Non-prise en charge assurance</li>
                  <li>• Coûts de mise en conformité urgente</li>
                  <li>• Perte de certifications qualité</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-green-500 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Shield className="w-16 h-16 mx-auto mb-6" />
          <h2 className="text-3xl font-bold mb-6">
            Assurez la Conformité de Vos Équipements
          </h2>
          <p className="text-xl mb-8 text-green-100">
            Audit gratuit de votre installation existante. Devis de mise en conformité sous 48h.
          </p>
          <a
            href="/#contact"
            className="inline-block bg-white text-green-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-50 transition-colors"
          >
            Demander un Audit Gratuit
          </a>
        </div>
      </section>
    </div>
  );
};

export default ConformiteCarsat;
